import React from 'react';
import { Card } from 'react-bootstrap';

import plusIcon from '../../../assets/add_dark.svg';

interface Props {
  onClick: () => void;
}

const AddCard = ({ onClick }: Props) => (
  <Card style={{ width: '160px' }}>
    <Card.Body style={{ padding: '65px 50px' }}>
      <Card.Img className="icon" src={plusIcon} onClick={onClick} />
    </Card.Body>
  </Card>
);

export default AddCard;
